<template>
  <div>
    <div class="bigbox">
      <div class="left">
        <div class="left_top">
          <div class="center-01">
            <h3>快来创建一个新工单吧！</h3>
            <div class="lefttop_right">
              <div
                @click="goPage(10)"
                v-show="worktotal == 0"
                style="
                  padding: 5px 10px;
                  background: #b0deff;
                  cursor: pointer;
                  border-radius: 5px;
                  color: #fff;
                  margin-right: 10px;
                "
              >
                历史工单
              </div>
              <div
                @click="goPage(10)"
                v-show="worktotal > 0"
                style="
                  padding: 5px 10px;
                  background: red;
                  cursor: pointer;
                  border-radius: 5px;
                  color: #fff;
                  margin-right: 10px;
                "
              >
                有{{ worktotal }}条历史工单
              </div>
              <div
                @click="goPage(11)"
                style="
                  padding: 5px 10px;
                  background: #66d7b7;
                  cursor: pointer;
                  border-radius: 5px;
                  color: #fff;
                "
              >
                记工单
              </div>
            </div>
          </div>
          <div style="display: flex; width: 100%">
            <div class="left_top_left">
              <div class="problem_box">
                <div class="problem_title">问题描述：</div>
                <div class="problem_input">
                  <Icon
                    v-show="getText"
                    type="ios-close-circle"
                    @click="clearGetText()"
                    class="clear_icon"
                    size="16"
                  />
                  <Input
                    v-model="getText"
                    type="textarea"
                    :autosize="{ minRows: 4, maxRows: 4 }"
                    placeholder="请输入或点击下方文字选择"
                    @on-change="onFaultTypeText"
                  ></Input>
                </div>
              </div>
              <div class="slideshow_box">
                <div
                  class="slideshow_model"
                  :style="
                    isSlideshow
                      ? { height: 'auto', minHeight: '30px', zIndex: 6 }
                      : { height: '30px' }
                  "
                >
                  <div v-show="!isSlideshow">
                    <span
                      class="slideshow_box_item"
                      v-for="item in data"
                      :key="item.id"
                      @click="loadData(item)"
                      >{{ item.descr }}</span
                    >
                  </div>
                  <div v-show="isSlideshow" class="sum-card-box2">
                    <div class="center-02">
                      <div class="center-02Search">
                        <Input
                          v-model="descr"
                          placeholder="请输入关键词"
                          clearable
                          @on-change="Search1(descr)"
                          icon="ios-search"
                        />
                      </div>
                      <div class="center-03">
                        <Table
                          :columns="columns"
                          :data="data"
                          max-height="500"
                          highlight-row
                          @on-row-click="rowClick"
                        >
                        </Table>
                      </div>
                    </div>
                  </div>
                  <div class="slideshow_box_icon" @click="onSlideshow()">
                    <img :src="isSlideshow ? pullTop : pullDown" alt="" />
                  </div>
                </div>
              </div>
              <div class="select_box" v-if="!patient">
                <div class="select_box_item select_box_item1">
                  <p><span style="color: red">*</span> 科室信息：</p>
                  <el-select
                    v-model="DepartmentValue"
                    class="Select"
                    filterable
                    remote
                    reserve-keyword
                    placeholder="请选择或搜索科室电话、名称、地址（楼宇-楼层）"
                    :remote-method="remoteMethod1"
                    @change="OnDepartment(DepartmentValue)"
                    :loading="loading1"
                  >
                    <el-option
                      v-for="item in deskList"
                      :key="item.id"
                      :label="
                        item.deskName +
                        (item.address ? '/' + item.address : '') +
                        (item.phone ? '/' + item.phone : '')
                      "
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div class="select_box_item">
                  <p>设备信息：</p>
                  <el-select
                    class="Select"
                    v-model="EquipmentValue"
                    filterable
                    remote
                    reserve-keyword
                    :remote-method="remoteMethod2"
                    placeholder="请选择或搜索设备编号、类型、型号、SN号"
                    clearable="true"
                    :loading="loading2"
                    @change="SelectEquipment(EquipmentValue)"
                  >
                    <el-option
                      v-for="item in EquipmentList"
                      :value="item.Num"
                      :key="item.id"
                      :label="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div class="select_box_item">
                  <p><span style="color: red">*</span>故障类型：</p>
                  <Select
                    class="Select"
                    filterable
                    v-model="typeIds"
                    placeholder="请选择问题或故障类型"
                    @on-change="loaduserData(typeIds)"
                  >
                    <Option
                      v-for="item in workList"
                      :value="item.typeId"
                      :key="item.typeId"
                      >{{ item.name }}
                    </Option>
                  </Select>
                </div>
                <div v-if="!EquipmentValue" class="select_box_item">
                  <p>地址：</p>
                  <div class="SelectAddress">
                    <Select
                      class="SelectBuilding"
                      v-model="buildingId"
                      filterable
                      placeholder="请选择楼宇"
                      clearable="true"
                      @on-change="selectBuilding"
                      @on-clear="buildingClear"
                    >
                      <Option
                        v-for="item in buildingList"
                        :value="item.id"
                        :key="item.id"
                        >{{ item.buildingName }}
                      </Option>
                    </Select>
                    <Select
                      class="SelectFloor"
                      v-model="floorId"
                      filterable
                      placeholder="请选择楼层"
                      clearable="true"
                    >
                      <Option
                        v-for="item in floorList"
                        :value="item.floorName"
                        :key="item.id"
                        >{{ item.floorName }}
                      </Option>
                    </Select>
                    <Input
                      v-model="room"
                      class="inputRoom"
                      placeholder="请输入房间号"
                    ></Input>
                    <!-- <Select class="SelectRoom" v-model="DepartmentValue" filterable placeholder="请选择或搜索科室"
                      clearable="true" @on-change="OnDepartment(DepartmentValue)">
                      <Option v-for="item in deskList" :value="item.id" :key="item.id">{{ item.deskName }}
                      </Option>
                    </Select> -->
                  </div>
                </div>
              </div>
              <!--   <div class="select_box" v-if="patient">
                <div class="select_box_item">
                  <p><span style="color: red">*</span> 病人信息:</p>
                  <Select class="SelectDesk" v-model="patientId" filterable placeholder="请选择病人信息" clearable="true">
                    <Option v-for="item in patientList" :value="item.id" :key="item.id">{{ item.patientName }}
                    </Option>
                  </Select>
                </div>
                <div class="select_box_item">
                  <p><span style="color: red">*</span> 患者所在科室:</p>
                  <Select class="SelectDesk" v-model="deskId" filterable placeholder="请选择或搜索科室" clearable="true">
                    <Option v-for="item in transportList" :value="item.id" :key="item.id">{{ item.deskName }}
                    </Option>
                  </Select>
                </div>
                <div class="select_box_item">
                  <p><span style="color: red">*</span> 护送到手术间:</p>
                  <Select class="SelectDesk" v-model="transferDeskId" filterable placeholder="请选择或搜索科室"
                    clearable="true">
                    <Option v-for="item in operationRoonmList" :value="item.id" :key="item.id">{{ item.deskName }}
                    </Option>
                  </Select>
                </div>
              </div> -->
            </div>
            <div class="left_top_right">
              <div class="left-02" v-html="programme" v-if="programme"></div>
              <div class="left-img" v-if="!programme">
                <img
                  class="img_gif"
                  src="../../../assets/img/gif_img6.png"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div v-if="!patient" class="workleft-1">
            <div class="workleft-11">
              <RadioGroup
                v-model="sendType"
                @on-change="changeOrderType(sendType)"
                class="RadioGroup"
              >
                <Radio :label="2">自动派单</Radio>
                <Radio :label="3">抢单派单</Radio>
                <Radio :label="1">手动派单</Radio>
              </RadioGroup>
              <Select
                class="left-12-Select"
                v-model="engineer1"
                placeholder="请选择维修员"
                clearable="true"
                @on-change="Selectengineer2(engineer1)"
                v-show="single == false ? true : false"
              >
                <Option
                  v-for="item in engineerList2"
                  :value="item.nickName"
                  :key="item.userId"
                  >{{ item.nickName }}
                </Option>
              </Select>
            </div>
          </div>
          <!-- <div v-if="patient" class="workleft-1">
            <div class="workleft-11">
              <RadioGroup v-model="sendTypePatient" @on-change="changeOrderTypePatient(sendTypePatient)"
                class="RadioGroup">
                <Radio :label="2">自动派单</Radio>
                <Radio :label="3">抢单派单</Radio>
                <Radio :label="1">手动派单</Radio>
              </RadioGroup>
              <Select class="left-12-Select" v-model="engineerPatient" placeholder="请选择护工" clearable="true"
                @on-change="SelectengineerPatient(engineerPatient)" v-show="singlePatient == false ? true : false">
                <Option v-for="item in engineerListPatient" :value="item.nickName" :key="item.userId">{{ item.nickName
                }}
                </Option>
              </Select>
            </div>
          </div> -->
          <div v-if="!patient" class="workleft-2">
            <Button
              type="info"
              @click="newWork"
              :disabled="isNewWork"
              size="default"
              class="button2"
              >保 存
            </Button>
          </div>
          <!--  <div v-if="patient" class="workleft-2">
            <Button type="info" @click="newWorkPatient" size="default" class="button2">保 存
            </Button>
          </div> -->
        </div>
        <div class="left_bottom">
          <div class="center-01">
            <h3>工单</h3>
            <div
              @click="goPage(1)"
              style="
                display: flex;
                width: 100px;
                align-items: center;
                justify-content: right;
                cursor: pointer;
              "
            >
              查看详情
              <img
                src="../../../assets/img/right_info.png"
                alt=""
                style="margin-left: 10px"
              />
            </div>
          </div>
          <el-table
            :data="workOrderListData"
            style="width: 100%"
            height="300px"
          >
            <el-table-column
              prop="department"
              label="部门"
              align="left"
              width="180px"
            >
            </el-table-column>
            <el-table-column prop="descr" label="故障描述" align="left">
              <template slot-scope="scope">
                <div class="descr_box">
                  <div
                    :class="
                      workOrderTime(scope.row.descr, 1) > 30
                        ? 'descr_left descr_left_b'
                        : 'descr_left descr_left_a'
                    "
                  >
                    <img
                      src="../../../assets/img/timeIcon.png"
                      class="descr_left_icon"
                      alt=""
                    />
                    <div class="descr_left_text">
                      {{ workOrderTime(scope.row.descr, 2) }}
                    </div>
                  </div>
                  <div class="descr_right">
                    {{ workOrderTime(scope.row.descr, 3) }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="state"
              label="处理状态"
              width="100"
              align="left"
            >
              <template slot-scope="scope">
                <span
                  :style="{
                    color:
                      scope.row.state == 1
                        ? '#4991ff'
                        : scope.row.state == 2
                        ? '#ff0000'
                        : scope.row.state == 4
                        ? '#df985c'
                        : '',
                  }"
                  >{{
                    scope.row.state == 1
                      ? "待处理"
                      : scope.row.state == 2
                      ? "处理中"
                      : scope.row.state == 4
                      ? "挂起中"
                      : ""
                  }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="maintainerName"
              label="处理人"
              width="100"
              align="left"
            >
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="right">
        <div class="right-0">
          <Card
            class="sum-card-box"
            dis-hover
            :padding="0"
            style="background: #fff"
          >
            <div class="right-01">
              <img
                src="../../../assets/icon/homeImage/OnlineEngineer.png"
                alt=""
              />
              <h3>在线工程师</h3>
            </div>
            <div class="right-02">
              <div
                v-for="(item, index) in engineerList"
                :key="index"
                class="engineer"
              >
                <div style="margin-right: 2px">
                  <el-avatar
                    shape="circle"
                    :size="40"
                    :src="
                      item.avatar
                        ? item.avatar.includes('http')
                          ? item.avatar
                          : IMAGE_HOST + item.avatar
                        : item.avatar
                    "
                    @error="errorHandler"
                  >
                    <img :src="item.sex == 1 ? useravatar_1 : useravatar_2" />
                  </el-avatar>
                </div>
                <div class="engineerbox">
                  <div class="engineer-name">
                    <Poptip
                      trigger="hover"
                      word-wrap
                      width="300"
                      :content="item.typeName"
                    >
                      <span class="nickName">{{ item.nickName }}─</span>
                      <span class="type">{{ item.type }}</span>
                    </Poptip>
                  </div>
                  <div class="engineer-state">
                    <p
                      v-show="
                        item.pendingOrder == 0 && item.beingProcessed == 0
                          ? true
                          : false
                      "
                    >
                      <Icon type="ios-radio-button-on" color="green" />
                      空闲
                    </p>
                    <p
                      v-show="
                        item.pendingOrder == 0 && item.beingProcessed == 0
                          ? false
                          : true
                      "
                    >
                      未接单<span style="color: red">{{
                        item.pendingOrder
                      }}</span>
                    </p>
                    <p
                      v-show="
                        item.pendingOrder == 0 && item.beingProcessed == 0
                          ? false
                          : true
                      "
                    >
                      处理中<span style="color: #ffc000">{{
                        item.beingProcessed
                      }}</span>
                    </p>
                    <p
                      v-show="
                        item.pendingOrder == 0 && item.beingProcessed == 0
                          ? false
                          : true
                      "
                    >
                      已完成<span style="color: green">{{
                        item.completed
                      }}</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import siblingCall from "@/utils/siblingCall";
import newWork from "./newWork.vue"; //快速报修
import Change from "../../workOrder/question";
import WorkOrderEdit from "./workOrderEdit.vue";
import Historicalworkorder from "./Historicalworkorder.vue";
// import Task from "../../sysTask/edit.vue";
import pullDown from "../../../assets/img/pull-down.png";
import pullTop from "../../../assets/img/pull-top.png";
import useravatar_1 from "./../../../assets/img/useravatar_1.png";
import useravatar_2 from "./../../../assets/img/useravatar_2.png";
import { IMAGE_HOST } from "@/../config";
import dayjs from "dayjs";

export default {
  name: "simple",
  components: { newWork, Change },
  data() {
    return {
      IMAGE_HOST: IMAGE_HOST,
      useravatar_1: useravatar_1,
      useravatar_2: useravatar_2,
      //时间选择器时间
      pData: null,
      // patient: false, // 病人/手术转运相关，已注释
      // patientId: "",
      // patientList: {},
      // transferContent: "",
      // nursingId: "",
      // sendTypePatient: 1,
      // transferDeskId: "",
      // transportList: [],
      // operationRoonmList: [],
      // singlePatient: true,
      DepartmentValue: "", //科室信息
      repairDeskInfo: "",
      transferDeskInfo: "",
      EquipmentValue: "", //设备信息
      value: "",
      workTypes2: [],
      workTypesTwo: [],
      selectModel: null,
      selectModelTwo: null,
      textarea1: "",
      deskList: [], //科室列表
      EquipmentList: {}, //设备列表
      FaultTypeText: "", //故障类型
      guzhang: "请点击上方文字选择",
      OrderType: "", //派单类型
      OrderTypeList: [
        { value: "自动派单", num: 1 },
        { value: "手动派单", num: 2 },
        { value: "抢单派单", num: 3 },
      ],
      engineer1: "",
      engineerPatient: "",
      engineerList2: [], //维修员列表
      engineerListPatient: [],
      descr: "",
      data: [],
      data2: [],
      allData: [],
      allData2: [],
      workType: 1,
      name: "",
      columns: [
        {
          title: "问题描述",
          minWidth: 170,
          align: "left",
          key: "descr",
        },
      ],
      columns2: [
        {
          title: "故障类型",
          minWidth: 170,
          align: "left",
          key: "name",
          ellipsis: "true",
        },
      ],
      getText: "", //故障描述
      deskId: "", //科室id
      transferDeskId: "", //科室id
      //病人信息
      // patientId: "",
      // patientList: {},
      transferContent: "",
      nursingId: "",
      sendTypePatient: 1,
      facilityNo: "", //设备编号
      Keydepartment: "", //重点科室
      typeId: "", //工单类型ID
      typeIds: "",
      sendType: 2, //派单类型
      state: "", //状态
      maintainerId: "", //维修员ID
      // workOrderEdit: true,
      commonEdit: true,
      teackList: {},
      workList: [],
      // messageNum: 0,
      isSlideshow: false,
      isSlideshows: false,
      pullDown: pullDown,
      pullTop: pullTop,
      workOrderListData: [],
      buildingList: [],
      floorList: [],
      buildingId: "",
      buildingName: "",
      floorId: "",
      room: "",
      typeParentName: "",
      loading1: false,
      loading2: false,
      isNewWork: false,
      relatedWorkOrders: [],
      worktotal: 0,
      programme: "",
      workTypeModel: "",
      startTime: null,
      endTime: null,
    };
  },
  watch: {
    getText: "fetchRelatedWorkOrders",
    typeIds: "fetchRelatedWorkOrders",
    DepartmentValue: "fetchRelatedWorkOrders",
    EquipmentValue: "fetchRelatedWorkOrders",
  },
  async created() {
    if ($utils.data.get("auth", "authsCommonEdit") > 0) {
      this.commonEdit = true;
    } else {
      this.commonEdit = false;
    }
    await this.mouth();
    await this.search();
    await this.loadfaultData();
    await this.loadCommonData();
    this.changeOrderType(2);
    await this.loadWorkCommon();
    await this.loadTypeData();
    await this.onWorkOrderList();
    await this.getBuilding();
    await this.deskListMethod();
  },

  methods: {
    async fetchRelatedWorkOrders() {
      if (
        this.getText ||
        this.typeIds ||
        this.DepartmentValue ||
        this.EquipmentValue
      ) {
        let query = {
          descr: this.getText,
          typeId: this.typeIds,
          deskId: this.DepartmentValue,
          assetNum: this.EquipmentValue,
          state: 3,
          pageNum: 1,
          pageSize: 20,
        };
        Object.keys(query).forEach((key) => {
          if (!query[key]) delete query[key];
        });
        let res = await $utils.api.load(
          "/admin/system/work/historyWorkOrderList",
          query,
          "get"
        );
        if (res && res.rows) {
          this.worktotal = res.total;
        }
      }
    },
    handleRebuildWorkOrder(row) {
      // 问题描述
      this.getText = row.descr.split("]")[1] || "";
      // 故障类型
      this.typeIds = row.typeId || "";
      if (row.typeId) {
        this.loaduserData(row.typeId);
      }
      this.typeId = row.typeId || "";
      // 科室信息
      this.deskId = row.deskId || "";
      this.DepartmentValue = row.deskId || "";
      if (row.deskId) this.OnDepartment(this.deskId);
      // 设备信息
      this.facilityNo = row.facilityNo || "";
      this.EquipmentValue = row.facilityNo || "";
      //派单方式
      this.sendType = row.sendType;
      if (row.sendType === 1) this.single = false;
      else this.single = true;

      // 地址
      if (row.buildingId) this.buildingId = row.buildingId;
      if (row.buildingName) this.buildingName = row.buildingName;
      if (row.floorId) this.floorId = row.floorId;
      if (row.room) this.room = row.room;
    },
    async remoteMethod1(query) {
      let d = {};
      this.loading1 = true;
      if (query !== "") {
        d.deskName = query;
      }
      console.log(query);
      let res = await $utils.api.load(
        "/admin/system/desk/selectList",
        d,
        "get"
      );
      if (res && res.rows) {
        this.loading1 = false;
        this.deskList = res.rows;
        console.log(this.deskList);
      } else {
        this.loading1 = false;
      }
    },
    async remoteMethod2(query) {
      let d = {};
      this.loading2 = true;
      if (query !== "") {
        d.facilityName = query;
      }
      let res = await $utils.api.load(
        "/admin/system/facility/selectListSearch",
        d,
        "get"
      );
      if (res && res.rows) {
        this.loading2 = false;
        let list = res.rows;
        let arr = [];
        if (list.length > 0) {
          for (let i = 0; i < list.length; i++) {
            let item = list[i];
            let obj = {};
            obj.deskId = item.deskId;
            obj.value =
              item.assetNum + "_" + item.facilityName + "_" + item.facilityType;
            obj.Num = item.facilityNum;
            arr.push(obj);
          }
        }
        this.EquipmentList = arr;
      } else {
        this.loading2 = false;
      }
    },
    clearGetText() {
      this.getText = "";
      this.programme = "";
    },
    //选择故障类型下拉框
    async loadTypeData() {
      let q = {};
      q.typeId = this.typeId;
      // 通过pk查询字典数据
      let res = await $utils.api.load("/admin/system/workType/listFrame", q);
      if (res && res.rows) {
        let list = res.rows;
        if (list.length > 0) {
          let lists = [];
          list.forEach((obj) => {
            lists.push({ name: obj.name, typeId: obj.id });
            if (obj.deskList && obj.deskList.length > 0) {
              obj.deskList.forEach((item) => {
                const newObj = {
                  name: `${obj.name}-${item.name}`,
                  typeId: item.id,
                };
                lists.push(newObj);
              });
            }
          });
          this.workList = lists;
        }
      }
    },
    async loadWorkCommon() {
      // 通过pk查询字典数据
      let q = {};
      q.workType = 3;
      let res = await $utils.api.load(
        "/admin/system/common/mainList",
        q,
        "get"
      );
      if (res && res.rows) {
        this.teackList = res.rows;
      }
    },
    goPage(val) {
      if (val == 1) {
        $utils.url.push({
          name: "processing_list",
        });
      } else if (val == 10) {
        if (this.worktotal == 0) {
          this.$Modal.success({
            title: "提示",
            closable: true,
            width: "500px",
            okText: "取消",
            showOk: false,
            render: () => {
              return <h3>未查询到历史工单!请先填写相关信息！</h3>;
            },
          });
          return;
        }
        this.$Modal.success({
          title: "历史工单",
          closable: true,
          width: "1200px",
          okText: "取消",
          showOk: false,
          fullscreen: true,
          render: () => {
            return (
              <Historicalworkorder
                descr={this.getText ? this.getText : null}
                typeId={this.typeIds ? this.typeIds : null}
                deskId={this.DepartmentValue ? this.DepartmentValue : null}
                assetNum={this.EquipmentValue ? this.EquipmentValue : null}
                on-rebuild={this.handleRebuildWorkOrder}
              ></Historicalworkorder>
            );
          },
        });
      } else if (val == 11) {
        this.$Modal.success({
          title: "记工单",
          closable: true,
          width: "1000px",
          okText: "取消",
          showOk: false,
          render: () => {
            return (
              <WorkOrderEdit
                type="jilu"
                deskList={this.deskList}
                teackList={this.teackList}
                workList={this.workList}
              ></WorkOrderEdit>
            );
          },
        });
      }
      //  else if (val == 2) {
      //   $utils.url.push({
      //     name: "messageNotification_list",
      //   });
      // } else if (val == 3) {
      //   $utils.url.push({
      //     name: "deviceretrieval_list",
      //   });
      // } else if (val == 4) {
      //   /*   $utils.url.push({
      //     name: "Edit_Task",
      //   }); */
      //   this.$Modal.success({
      //     title: "新建任务",
      //     closable: true,
      //     width: "1000px",
      //     okText: "取消",
      //     showOk: false,
      //     action: "add",
      //     render: () => {
      //       return <Task></Task>;
      //     },
      //   });
      // } else if (val == 5) {
      //   $utils.url.push({
      //     name: "callcenter_list",
      //   });
      // } else if (val == 6) {
      //   $utils.url.push({
      //     name: "serveKnowledgeBase",
      //   });
      // } else if (val == 7) {
      //   $utils.url.push({
      //     name: "record_list",
      //   });
      // } else if (val == 8) {
      //   $utils.url.push({
      //     name: "hospitalbackstage",
      //   });
      // } else if (val == 9) {
      //   $utils.url.push({
      //     name: "contacts_list",
      //   });
      // }
    },
    onFaultTypeText() {
      if (!this.getText) {
        this.FaultTypeText = "";
      }
    },
    loadWorkTypes() {
      let q = {};
      $utils.api.load("/admin/system/workType/selectList", q).then((res) => {
        if (res && res.rows) {
          this.workTypes = res.rows;
        }
      });
    },

    //时间发生改变
    dtime(val) {
      let startData = val[0] || 0;
      let endData = val[1] || 0;
      this.startTime = startData;
      this.endTime = endData;
    },
    //实时
    async search(id) {
      let time = {};
      time.begin = this.startTime;
      time.end = this.endTime;
      time.workTypeId = this.workTypeModel;
      time.maiUserId = id;
      let res = await $utils.api.load(
        "/admin/homePage/getWorkEvaluate",
        time,
        "get"
      );
      this.simple_info = res.data;
    },
    //本月
    async mouth() {
      let res = await $utils.api.load(
        "/admin/homePage/getWorkEvaluatethisMonth"
      );
      if (res || res.data) {
        this.Mouth = res.data;
        let arr = res.data.onlineEngineer;
        if (arr != []) {
          let list = [];
          for (let i = 0; i < arr.length; i++) {
            const item = arr[i];
            let type;
            if (item.maiUser.type) {
              type = item.maiUser.type.split(",");
            }
            let result;
            if (type) {
              if (type.length <= 4) {
                result = type.join(", ");
              } else {
                result = type.slice(0, 3).join(", ");
              }
            }
            let obj = {
              beingProcessed: item.beingProcessed, //处理中
              completed: item.completed, //已完成
              pendingOrder: item.pendingOrder, //待接单
              nickName: item.maiUser.nickName, //维修员名字
              type: result,
              typeName: item.maiUser.type
                ? item.maiUser.type.slice(0, -1)
                : item.maiUser.type,
              avatar: item.maiUser.avatar,
            };
            list.push(obj);
          }
          this.engineerList = this.removeDuplicate(list);
        }
      }
    },
    //实时选择维修员
    // Selectengineer(id) {
    //   this.search(id);
    // },
    removeDuplicate(arr) {
      let len = arr.length;
      for (let i = 0; i < len; i++) {
        for (let j = i + 1; j < len; j++) {
          if (arr[i] === arr[j]) {
            arr.splice(j, 1);
            len--; // 减少循环次数提高性能
            j--; // 保证j的值自加后不变
          }
        }
      }
      return arr;
    },

    //--------------新建工单逻辑---------------

    //常用语跳转
    tiaozhaun(item) {
      if (item == 1) {
        $utils.url.push({
          name: "worktype_list",
        });
      } else if (item == 2) {
        $utils.url.push({
          name: "commondescr_add",
        });
      } else if (item == 3) {
        $utils.url.push({
          name: "workOrder_add",
        });
      }
    },
    //派单类型
    changeOrderType(item) {
      if (item == 1) {
        this.single = false;
      } else {
        this.maintainerId = null;
        this.single = true;
      }
    },
    //重点科室
    department(status) {
      if (status == true) {
        this.Keydepartment = 1;
      } else {
        this.Keydepartment = 2;
      }
    },
    //选择维修员
    Selectengineer2(item) {
      if (this.engineerList2.length > 0) {
        for (let i = 0; i < this.engineerList2.length; i++) {
          let a = this.engineerList2[i];
          if (a.nickName == item) {
            this.maintainerId = a.userId;
          }
        }
      }
    },
    //选择设备
    async SelectEquipment(item) {
      let list = this.EquipmentList;
      if (list.length > 0) {
        for (let i = 0; i < list.length; i++) {
          let a = list[i];
          if (!item) {
            await this.loadCommonData(null);
          }
          if (a.Num == item) {
            this.facilityNo = a.Num;
            this.DepartmentValue = a.deskId;
            await this.loadfaultData(this.facilityNo);
          }
        }
      } else {
        this.data2 = [];
      }
    },
    //选择故障类型
    async loadfaultData(facilityNo) {
      if (facilityNo) {
        let q = {};
        q.facilityNum = facilityNo;
        let res = await $utils.api.load(
          `/admin/system/facility/workTypeHome`,
          q
        );
        if (res && res.rows) {
          let list = res.rows;
          if (list.length === 0) {
            this.guzhang = "该设备暂无故障类型";
            this.allData2 = [];
            this.data2 = [];
            this.FaultTypeText = "";
          } else {
            await this.loadCommonData(list[0].id);
            this.typeIds = list[0].id;
            await this.loadTypeData();
          }
        } else {
          this.guzhang = "该设备暂无故障类型";
          this.allData2 = [];
          this.data2 = [];
          this.FaultTypeText = "";
        }
      }
    },
    //查询维修员
    loaduserData(typeParentId) {
      let typeId = "";
      if (typeParentId.name) {
        this.typeParentName = typeParentId.name;
        typeId = typeParentId ? typeParentId.typeId : this.typeId;
        this.typeIds = typeParentId ? typeParentId.typeId : this.typeId;
      } else {
        typeId = typeParentId ? typeParentId : this.typeId;
        this.typeIds = typeParentId ? typeParentId : this.typeId;
      }
      this.isSlideshows = false;
      // console.log(typeId);
      // 通过pk查询字典数据
      $utils.api.load(`/admin/system/maiUser/type/${typeId}`).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let arr = [];
          if (ll.length > 0) {
            for (let i = 0; i < ll.length; i++) {
              let item = ll[i];
              let obj = {
                nickName: item.nickName,
                userId: item.userId,
              };
              arr.push(obj);
            }
            this.engineerList2 = arr;
          }
        }
      });
    },
    Search2(descr) {
      let keyword = this.name;
      let allData = this.allData2;
      let newData = [];
      for (let index = 0; index < allData.length; index++) {
        let item = allData[index] || {};
        let descrOld = item.name;
        if (descrOld.indexOf(keyword) != -1) {
          newData.push(item);
          this.data2 = newData;
        }
      }
    },
    Search1(descr) {
      let keyword = this.descr;
      let allData = this.allData;
      let newData = [];
      for (let index = 0; index < allData.length; index++) {
        let item = allData[index] || {};
        let descrOld = item.descr;
        if (descrOld.indexOf(keyword) != -1) {
          newData.push(item);
          this.data = newData;
        }
      }
    },
    clickss(item) {
      this.descr = item;
      this.Search1(this.descr);
      if (item == "手术转运") {
        this.patient = true;
      } else {
        this.patient = false;
      }
    },
    async loadCommonData(id) {
      let q = {};
      q.workTypeId = id;
      q.workType = 1;
      let res = await $utils.api.load(
        "/admin/system/common/noPageCommonList",
        q
      );
      if (res) {
        if (res.code > 0) {
          let list = res.rows || [];
          this.allData = list;
          this.data = list;
        }
      }
    },
    async rowClick(row) {
      // 点击选择行
      await this.loadData(row);
    },
    async loadData(row) {
      this.isSlideshow = false;
      if (row.recommendation != "") {
        this.programme = row.recommendation;
      } else {
        this.programme = "暂无处理方案";
      }
      let q = {};
      q.id = row.id;
      let res = await $utils.api.load("/admin/system/common/pageList", q);
      if (res) {
        if (res.code > 0) {
          this.typeId = res.data.id;
          this.typeIds = res.data.id;
          this.typeParentName = res.data.name;
          this.FaultTypeText = res.data.name;
          if (res.data.surgicalTransport == 2) {
            this.patient = false;
            this.getText = row.descr;
          } else {
            this.patient = true;
          }
          this.loaduserData(res.data.id); //查询维修员
        }
      }
    },
    clickRow(data) {
      this.textarea1 = this.textarea1 + data;
    },
    async workTypeMethod() {
      let q = {};
      let res = await $utils.api.load("/admin/system/workType/homeList", q);
      this.workTypes2 = res.rows;
    },
    async workTypeTwoMethod(value) {
      if (value) {
        let res = await $utils.api.load(
          "/admin/system/workType/parentId/" + parseInt(value)
        );
        this.workTypesTwo = res.data;
      } else {
        this.selectModelTwo = null;
        this.workTypesTwo = [];
      }
    },
    async deskListMethod() {
      let res = await $utils.api.load("/admin/system/desk/selectList");
      this.deskList = res.rows;
      for (let i = 0; i < this.deskList.length; i++) {
        let workInfotemp = "";
        if (
          this.deskList[i].deskName !== null &&
          this.deskList[i].deskName !== undefined
        ) {
          workInfotemp = this.deskList[i].deskName;
        }
        if (
          this.deskList[i].principal !== null &&
          this.deskList[i].principal !== undefined
        ) {
          workInfotemp = workInfotemp + "/" + this.deskList[i].principal;
        }
        if (
          this.deskList[i].phone !== null &&
          this.deskList[i].phone !== undefined
        ) {
          workInfotemp = workInfotemp + "/" + this.deskList[i].phone;
        }
        if (
          this.deskList[i].address !== null &&
          this.deskList[i].address !== ""
        ) {
          workInfotemp = workInfotemp + "/" + this.deskList[i].address;
        }
        // this.deskList[i].deskName = workInfotemp;
      }
    },
    async usefulPxpressions() {
      this.$refs.tanchuang.loadData(1);
      this.$refs.tanchuang.open();
    },
    async OnDepartment(deskId) {
      if (this.deskId) {
        // this.getText = "";
        // this.programme = "";
        this.EquipmentList = [];
        this.EquipmentValue = "";
        // this.FaultTypeText = "";
      }
      this.deskId = deskId;
      let q = {};
      q.state = 2;
      q.deskId = deskId;
      let res = await $utils.api.load(
        "/admin/system/facility/selectListSearch",
        q,
        "get"
      );
      let list = res.rows;
      let arr = [];
      if (list.length > 0) {
        for (let i = 0; i < list.length; i++) {
          let item = list[i];
          let obj = {};
          obj.deskId = item.deskId;
          obj.value =
            item.assetNum + "_" + item.facilityName + "_" + item.facilityType;
          obj.Num = item.facilityNum;
          arr.push(obj);
        }
      } else {
        this.EquipmentValue = "";
      }
      this.EquipmentList = arr;
    },
    //提交工单
    // 科室id(deskId)   设备编号(facilityNo)  重点科室(1,2)  故障类型有二级给二级id,没有给一级(typeId)
    // 故障描述(descr)  派单类型(sendType  自动传1,手动传2)  状态(state=1)  维修员ID(maintainerId)
    async newWork() {
      this.isNewWork = true;
      let q = {};
      q.deskId = this.deskId;
      this.typeId = this.typeIds;
      if (this.typeId == "") {
        this.isNewWork = false;
        return $utils.toast.error("故障类型不可为空");
      }
      if (this.getText == "") {
        this.isNewWork = false;
        return $utils.toast.error("问题描述不可为空");
      }
      if (this.sendType == 1 && !this.maintainerId) {
        this.isNewWork = false;
        return $utils.toast.error("手动派单维修员不可为空");
      } else {
        q.maintainerId = this.maintainerId;
      }
      q.facilitySite = this.buildingName
        ? this.buildingName +
          (this.floorId ? "-" + this.floorId : "") +
          (this.room ? "-" + this.room : "")
        : this.floorId
        ? this.floorId + (this.room ? "-" + this.room : "")
        : this.room
        ? this.room
        : "";
      q.descr = this.getText;
      q.typeId = this.typeId;
      if (this.facilityNo == "") {
        q.isFastOrder = 1;
      } else {
        q.isFastOrder = 0;
        q.facilityNo = this.facilityNo;
      }
      q.repairSource = 3;
      q.sendType = this.sendType;
      q.state = 1;
      q.repairSource = 3;
      q.maintainType = 2;
      let res = await $utils.api.load("/admin/system/work/flashAdd", q, "post");
      if (res.code == 200) {
        this.isNewWork = false;
        await $utils.toast.success("保存成功");
        await this.onWorkOrderList();
        // this.$emit("complete");
        // this.$router.go(0);
        this.rest();
        siblingCall.$emit("event");
      } else {
        this.isNewWork = false;
        $utils.toast.error("保存失败");
      }
    },
    diaoyong() {
      siblingCall.$emit("event");
    },
    rest() {
      this.engineerPatient = "";
      this.nursingId = "";
      this.singlePatient = true;
      this.deskId = "";
      this.transferDeskId = "";
      this.sendTypePatient = 2;
      // this.nursingId = "";
      // this.patientName = "";
      this.transferContent = "";
      this.transferDeskInfo = "";
      this.repairDeskInfo = "";
      this.programme = "";
      // this.RepairText = "";
      this.DepartmentValue = "";
      this.EquipmentValue = "";
      this.FaultTypeText = "";
      this.getText = "";
      this.OrderType = "";
      this.engineer1 = "";
      this.workTypeModel = "";
      // this.matainerModel = "";
      this.pData = null;
      this.startTime = null;
      this.endTime = null;
      // console.log(this.search());
      this.search();
      this.typeIds = "";
      this.typeParentName = "";
      this.buildingId = "";
      this.floorId = "";
      this.buildingName = "";
      this.floorList = [];
      this.room = "";
    },

    onSlideshow() {
      this.isSlideshow = !this.isSlideshow;
    },
    onSlideshows() {
      this.isSlideshows = !this.isSlideshows;
    },
    async onWorkOrderList() {
      let d = {};
      $utils.api
        .load("/admin/system/work/unfinishedList", d, "get")
        .then((res) => {
          if (res.code == 200) {
            this.workOrderListData = res.rows;
          }
        });
    },
    workOrderTime(e, type) {
      if (type == 1) {
        let timeA = Number(e.split("]")[0]);
        return timeA;
      } else if (type == 2) {
        let timeB = Number(e.split("]")[0]);
        let returnTime = "";
        if (timeB >= 60 * 24) {
          let d = parseInt(timeB / (60 * 24));
          let h = parseInt((timeB % (60 * 24)) / 60);
          let m = (timeB % (60 * 24)) % 60;
          returnTime = `${d}天${h}时${m}分`;
        } else if (60 * 24 >= timeB && timeB >= 60) {
          let ha = parseInt(timeB / 60);
          let ma = timeB % 60;
          returnTime = `${ha}时${ma}分`;
        } else {
          returnTime = `${timeB}分`;
        }
        return returnTime;
      } else if (type == 3) {
        let timeC = e.split("]")[1];
        return timeC;
      }
    },
    async getBuilding() {
      let d = {};
      let res = await $utils.api.load("admin/system/building/list", d, "get");
      // console.log(res);
      if (res.code == 200) {
        this.buildingList = res.rows;
      }
    },
    async getFloor(e) {
      let d = {
        buildingId: e,
      };
      let res = await $utils.api.load("admin/system/floor/list", d, "get");
      // console.log(res);
      if (res.code == 200) {
        this.floorList = res.rows;
      }
    },
    selectBuilding(e) {
      if (e) {
        this.buildingList.forEach((item) => {
          if (item.id == e) {
            this.buildingName = item.buildingName;
          }
        });
        this.getFloor(e);
      }
    },
    buildingClear() {
      this.floorList = [];
      this.floorId = "";
      this.buildingId = "";
      this.buildingName = "";
    },
  },
  mounted() {
    siblingCall.$on("event", () => {
      this.search();
      this.mouth();
    });
  },
  computed: {
    isSystem() {
      return $utils.data.get("auth", "is_system") || false;
    },
    extRender() {
      return ["change"];
    },
  },
};
</script>
<style lang="less" scoped>
.nav_box {
  display: flex;
  justify-content: space-around;
  // border-bottom: 1px solid #eee;
  padding-bottom: 10px;
  margin-bottom: 10px;
  background: #f5f7fa;
  border: 1px solid #e8eaec;
  border-radius: 4px;
  padding: 16px;
  box-sizing: border-box;

  .item {
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
}

.descr_box {
  display: flex;
  align-items: center;

  .descr_left_icon {
    width: 20px;
    height: 20px;
    margin-right: 3px;
  }

  .descr_left_text {
    height: 20px;
    line-height: 20px;
    white-space: nowrap;
  }

  .descr_left_a {
    background-color: #c2f1c8;
    color: #47d45a;
  }

  .descr_left_b {
    background-color: #f6c6ad;
    color: #ff0000;
  }

  .descr_left {
    padding: 2px 5px;
    border-radius: 5px;
    margin-right: 5px;
    display: flex;
    align-items: center;
  }
}

.bigbox {
  width: 100%;
  display: flex;
  justify-content: space-between;

  .left {
    height: 100%;
    width: 75.5%;

    .left_top {
      width: 100%;
      background: #f5f7fa;
      border: 1px solid #e8eaec;
      border-radius: 4px;
      padding: 16px;
      box-sizing: border-box;

      .center-01 {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 9px;

        img {
          margin-right: 5px;
        }

        .lefttop_right {
          display: flex;
        }
      }

      .left_top_left {
        width: 65%;
        display: flex;
        flex-direction: column;
        align-items: end;

        .problem_box {
          display: flex;
          width: 100%;

          .problem_title {
            width: 100px;
            text-align: right;
            box-sizing: border-box;
            padding-right: 10px;
          }

          .problem_input {
            width: calc(100% - 100px);
            position: relative;

            .clear_icon {
              position: absolute;
              right: 10px;
              top: 50%;
              transform: translateY(-50%);
              z-index: 2;
            }
          }
        }

        .slideshow_box {
          width: calc(100% - 100px);
          // overflow: hidden;
          position: relative;
          padding-right: 15px;
          margin: 10px 0;
          height: 30px;
          // padding: 10px;

          .slideshow_model {
            width: 100%;
            overflow: hidden;
            // position: absolute;
            padding-top: 6px;
            padding-left: 10px;
            padding-right: 30px;
            position: absolute;
            z-index: 2;
            background: #fff;
            border-radius: 8px;

            .sum-card-box2 {
              padding-right: 10px;
              padding-bottom: 20px;

              .center-02 {
                // height: 493px;

                .center-02Search {
                  margin-top: 5px;
                  margin-bottom: 10px;
                }

                .center-BSS {
                  color: #2a75ed;
                  border-radius: 3px;
                  border: 1px rgb(76, 128, 243) solid;
                }

                .center-SS {
                  color: #2a75ed;
                  margin-right: 3px;
                  border-radius: 3px;
                  border: 1px rgb(28, 123, 232) solid;
                }

                .center-03 {
                  // height: 100%;
                  // overflow: auto;

                  /deep/ .ivu-table {
                    width: inherit;
                    // height: 100%;
                    max-width: 100%;
                    overflow: hidden;
                    color: #3871f1;
                    font-size: 14px;
                    background-color: #fff;
                    box-sizing: border-box;
                  }
                }
              }
            }
          }

          .slideshow_box_item {
            display: inline-block;
            margin-right: 20px;
            color: #2a75ed;
            cursor: pointer;
          }

          .slideshow_box_icon {
            position: absolute;
            right: 10px;
            top: 7px;
          }
        }

        .select_box {
          // display: flex;
          // justify-content: space-between;
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: end;

          .slideshow_box1 {
            width: calc(100% - 100px);
            // overflow: hidden;
            position: relative;
            padding-right: 15px;
            // margin: 10px 0;
            height: 30px;
            // padding: 10px;

            .slideshow_model1 {
              width: 100%;
              overflow: hidden;
              // position: absolute;
              padding-top: 6px;
              padding-left: 10px;
              padding-right: 30px;
              position: absolute;
              top: 0;
              z-index: 2;
              background: #fff;
              border-radius: 8px;

              .sum-card-box2 {
                padding-right: 10px;
                padding-bottom: 20px;

                .center-02 {
                  // height: 493px;

                  .center-02Search {
                    margin-top: 5px;
                    margin-bottom: 10px;
                  }

                  .center-BSS {
                    color: #2a75ed;
                    border-radius: 3px;
                    border: 1px rgb(76, 128, 243) solid;
                  }

                  .center-SS {
                    color: #2a75ed;
                    margin-right: 3px;
                    border-radius: 3px;
                    border: 1px rgb(28, 123, 232) solid;
                  }

                  .center-03 {
                    // height: 100%;
                    // overflow: auto;

                    /deep/ .ivu-table {
                      width: inherit;
                      // height: 100%;
                      max-width: 100%;
                      overflow: hidden;
                      color: #3871f1;
                      font-size: 14px;
                      background-color: #fff;
                      box-sizing: border-box;
                    }
                  }
                }
              }
            }

            .slideshow_box_item1 {
              display: inline-block;
              margin-right: 20px;
              color: #2a75ed;
              cursor: pointer;
            }

            .slideshow_box_icon1 {
              position: absolute;
              right: 10px;
              top: 7px;
            }
          }

          .select_box_item {
            width: 100%;

            .problem_input {
              width: calc(100% - 100px);
            }

            .problem_input_color {
              /deep/.ivu-input {
                color: red;
              }
            }
          }

          // .slideshow_box {
          //   margin: 0;
          // }

          > div {
            // width: 33%;
            display: flex;
            align-items: center;
            margin: 10px 0 0;

            > p {
              width: 100px;
              text-align: right;
              box-sizing: border-box;
              display: block;
              padding-right: 10px;
            }
          }

          .select_box_item1 {
            margin: 0;
          }

          .SelectDesk,
          .Select {
            width: calc(100% - 100px);
          }

          .SelectAddress {
            display: flex;
            width: calc(100% - 100px);
            box-sizing: border-box;

            .SelectBuilding {
              margin-right: 10px;
            }

            .inputRoom {
              margin-left: 10px;

              /deep/ .ivu-input:hover {
                border-color: #2db7f5 !important;
              }

              /deep/ .ivu-input:focus {
                border-color: #2db7f5 !important;
                box-shadow: 0 0 0 2px rgba(255, 24, 24, 0.2) !important;
              }

              /deep/ .ivu-input {
                border-color: #2db7f5 !important;
              }
            }
          }
        }
      }

      .left_top_right {
        width: 35%;

        .left-02 {
          width: 87.7%;
          border-radius: 5px;
          // background-color: #f3f3f3;
          border: 1px rgb(220, 222, 226) solid;
          height: 300px;
          overflow: auto;
          color: #ee0000;
          margin-bottom: 15px;
          margin-left: 6%;
        }

        .left-img {
          width: 87.7%;
          height: 300px;
          margin-bottom: 15px;
          margin-left: 6%;
          border: 1px rgb(220, 222, 226) solid;
          border-radius: 5px;
          display: flex;
          justify-content: center;

          .img_gif {
            // max-width: 100%;
            width: 100%;
            height: auto; /* 高度自动，保持原图比例 */
            object-fit: contain; /* 保持图片比例，完整显示 */
            display: block; /* 避免底部间隙 */
            max-height: 300px;
          }
        }
      }

      .workleft-1 {
        // height: 33px;
        min-height: 43px;
        width: 65%;
        padding-bottom: 10px;
        padding-top: 10px;
        padding-left: 100px;

        .workleft-11 {
          font-size: 12px;
          display: flex;
          justify-content: space-between;
          height: 33px;
          align-items: center;

          .RadioGroup {
            // width: 40%;
          }

          .left-12-Select {
            width: 40%;
          }
        }
      }

      .workleft-2 {
        bottom: 15px;

        .button2 {
          width: 100%;
        }
      }
    }

    .left_bottom {
      margin-top: 20px;
      background: #f5f7fa;
      border: 1px solid #e8eaec;
      border-radius: 4px;
      padding: 16px;
      box-sizing: border-box;

      .center-01 {
        width: 100%;
        display: flex;
        justify-content: space-between;
        margin-bottom: 5px;
      }

      /deep/ .el-table th.el-table__cell {
        background-color: #f8f8f9;
        color: #515a6e;
      }
    }

    .left-bottom {
      display: flex;
      justify-content: space-between;
    }

    .left-1,
    .left-2 {
      width: 49%;
    }

    .left-1 {
      .left-11 {
        margin-bottom: 20px;
        display: flex;
        justify-content: space-between;

        .text {
          display: flex;
          align-items: center;
        }

        img {
          width: 20px;
          display: inline-block;
        }

        h2 {
          display: inline-block;
          margin-left: 10px;
        }
      }

      .left-12 {
        margin-bottom: 25px;
        display: flex;
        justify-content: space-between;
        text-align: center;

        p {
          margin-bottom: 10px;
          color: black;
          font-size: 18px;
          line-height: 30px;
        }

        span {
          font-size: 30px;
        }

        div:nth-child(1) span {
          color: #66a4e2;
        }

        div:nth-child(2) span {
          color: #ee8781;
        }

        div:nth-child(3) span {
          color: #67d5b5;
        }

        div:nth-child(4) span {
          color: #829cf3;
        }
      }

      .left-13 {
        display: flex;
        justify-content: space-between;

        div {
          width: 50%;

          p {
            display: inline-block;
            margin-left: 10px;
          }
        }
      }
    }
  }

  .right {
    width: 23%;
    height: 100%;

    .right-01 {
      margin-bottom: 10px;
      display: flex;
      align-items: center;

      img {
        width: 20px;
        display: inline-block;
      }

      h3 {
        display: inline-block;
        margin-left: 10px;
      }
    }

    .right-02 {
      overflow: auto;
      height: 770px;
      overflow-x: hidden;
    }

    .right-1 {
      margin-top: 20px;
    }
  }
}

.bigBox {
  height: 593px;
  margin-top: 17px;
  display: flex;
  justify-content: space-between;

  .workleft {
    width: 68%;
    height: 100%;

    .center-01 {
      width: 100%;
      display: flex;
      justify-content: space-between;
    }

    h3 {
      margin-bottom: 10px;
    }

    .first-line {
      width: 100.7%;
      display: flex;
      justify-content: flex-start;
      margin-bottom: 15px;

      div {
        display: flex;
        justify-content: flex-start;
        width: 50%;

        .Select {
          width: 74%;
          display: inline-block;

          /deep/ .ivu-input[disabled] {
            background-color: #f3f3f3;
            opacity: 1;
            cursor: not-allowed;
            color: #3871f1;
          }

          /deep/ .ivu-input {
            display: inline-block;
            width: 100%;
            height: 32px;
            line-height: 1.5;
            padding: 4px 7px;
            font-size: 14px;
            border: 1px solid #dcdee2;
            border-radius: 4px;
            color: #3871f1;
            background-color: #fff;
            background-image: none;
            position: relative;
            cursor: text;
            transition: border 0.2s ease-in-out, background 0.2s ease-in-out,
              box-shadow 0.2s ease-in-out;
          }

          /deep/ .ivu-select-input {
            display: inline-block;
            height: 32px;
            line-height: 32px;
            padding: 0 24px 0 8px;
            font-size: 14px;
            outline: none;
            border: none;
            box-sizing: border-box;
            color: #3871f1;
            background-color: transparent;
            position: relative;
            cursor: pointer;
          }
        }

        p {
          font-size: 0.875rem;
          padding-top: 5px;
          text-align: left;
          width: 20%;
          min-width: 23%;
          display: inline-block;
          margin-right: 5px;
        }
      }
    }

    .second-line {
      width: 100.7%;
      display: flex;
      justify-content: flex-start;
      margin-bottom: 15px;

      div {
        display: flex;
        justify-content: flex-start;
        width: 100%;

        .SelectDesk {
          width: 87%;
          display: inline-block;

          /deep/ .ivu-input[disabled] {
            background-color: #f3f3f3;
            opacity: 1;
            cursor: not-allowed;
            color: #3871f1;
          }

          /deep/ .ivu-input {
            display: inline-block;
            width: 100%;
            height: 32px;
            line-height: 1.5;
            padding: 4px 7px;
            font-size: 14px;
            border: 1px solid #dcdee2;
            border-radius: 4px;
            color: #3871f1;
            background-color: #fff;
            background-image: none;
            position: relative;
            cursor: text;
            transition: border 0.2s ease-in-out, background 0.2s ease-in-out,
              box-shadow 0.2s ease-in-out;
          }

          /deep/ .ivu-select-input {
            display: inline-block;
            height: 32px;
            line-height: 32px;
            padding: 0 24px 0 8px;
            font-size: 14px;
            outline: none;
            border: none;
            box-sizing: border-box;
            color: #3871f1;
            background-color: transparent;
            position: relative;
            cursor: pointer;
          }
        }

        p {
          font-size: 0.875rem;
          padding-top: 5px;
          text-align: left;
          width: 10%;
          min-width: 11%;
          display: inline-block;
          margin-right: 5px;
        }
      }
    }

    .third-line {
      width: 100.7%;
      display: flex;
      justify-content: flex-start;
      margin-bottom: 15px;

      div {
        display: flex;
        justify-content: flex-start;
        width: 100%;

        .SelectDesk {
          width: 87%;
          display: inline-block;

          /deep/ .ivu-input[disabled] {
            background-color: #f3f3f3;
            opacity: 1;
            cursor: not-allowed;
            color: #3871f1;
          }

          /deep/ .ivu-input {
            display: inline-block;
            width: 100%;
            height: 32px;
            line-height: 1.5;
            padding: 4px 7px;
            font-size: 14px;
            border: 1px solid #dcdee2;
            border-radius: 4px;
            color: #3871f1;
            background-color: #fff;
            background-image: none;
            position: relative;
            cursor: text;
            transition: border 0.2s ease-in-out, background 0.2s ease-in-out,
              box-shadow 0.2s ease-in-out;
          }

          /deep/ .ivu-select-input {
            display: inline-block;
            height: 32px;
            line-height: 32px;
            padding: 0 24px 0 8px;
            font-size: 14px;
            outline: none;
            border: none;
            box-sizing: border-box;
            color: #3871f1;
            background-color: transparent;
            position: relative;
            cursor: pointer;
          }
        }

        p {
          font-size: 0.875rem;
          padding-top: 5px;
          text-align: left;
          width: 10%;
          min-width: 16%;
          display: inline-block;
          margin-right: 5px;
        }
      }
    }

    .workleft-0 {
      margin-top: 15px;

      p {
        font-size: 0.875rem;
        width: 12%;
        display: inline-block;
      }

      .left-01 {
        display: inline-block;
        width: 87.7%;
        vertical-align: top;

        /deep/ .ivu-input {
          display: inline-block;
          width: 100%;
          height: 16px;
          line-height: 1.5;
          padding: 4px 7px;
          font-size: 14px;
          border: 1px solid #dcdee2;
          border-radius: 4px;
          color: #3871f1;
          background-color: #fff;
          background-image: none;
          position: relative;
          cursor: text;
          transition: border 0.2s ease-in-out, background 0.2s ease-in-out,
            box-shadow 0.2s ease-in-out;
        }
      }
    }

    .left-12-Select {
      margin-left: 40%;
      position: absolute;
      bottom: 55px;
      width: 34.5%;
      display: inline-block;
    }
  }

  .workcenter {
    width: 30%;
    height: 100%;

    i {
      cursor: pointer;
    }

    .center-01 {
      width: 100%;
      margin-bottom: 3px;
      display: flex;
      justify-content: space-between;
    }

    .center-02 {
      height: 493px;

      .center-02Search {
        margin-top: 5px;
      }

      .center-BSS {
        color: #2a75ed;
        border-radius: 3px;
        border: 1px rgb(76, 128, 243) solid;
      }

      .center-SS {
        color: #2a75ed;
        margin-right: 3px;
        border-radius: 3px;
        border: 1px rgb(28, 123, 232) solid;
      }

      .center-03 {
        height: 100%;
        overflow: auto;

        /deep/ .ivu-table {
          width: inherit;
          height: 100%;
          max-width: 100%;
          overflow: hidden;
          color: #3871f1;
          font-size: 14px;
          background-color: #fff;
          box-sizing: border-box;
        }
      }
    }
  }
}

.sum-card-box2 {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  // background-color: #f9f9f9;

  .ivu-card-body {
    height: 100%;
  }

  .header_box {
    h3 {
      padding-top: 10px;
      margin-left: 15px;
    }
  }

  .item3 {
    height: 0px;
    margin-bottom: 2px;
    width: 100%;
  }

  .item4 {
    border-top: 1px solid #e8e8e8;
    padding-top: 5px;
    margin-top: 8px;
    font-size: 14px;
    line-height: 22px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    span:last-child {
      margin-left: 8px;
      color: rgba(0, 0, 0, 0.85);
    }
  }
}

.box2 {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-around;
  height: 100%;
  margin: 22px 0;

  .item {
    align-items: center;
    margin-top: 10px;
    margin-bottom: 10px;
    cursor: pointer;

    .image {
      width: 40px;
      height: 40px;
      display: block;
      margin-left: 10px;
    }

    .title {
      font-weight: 400;
      font-size: 0.875rem;
      color: rgb(16, 16, 16);
      font-style: normal;
      margin-top: 10px;
      text-align: right;
      width: 100%;
    }
  }
}

.sum-card-box {
  width: 100%;
  height: 100%;
  padding: 16px;
}

.box {
  display: flex;
  align-items: center;
  justify-items: center;
  height: 50px;
  margin-top: 20px;
  border-radius: 10px;

  .item1 {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background: #ccc;
    margin-right: 15px;
    margin-left: 10px;
  }

  .item2 {
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
    white-space: nowrap;
    margin-top: 4px;
    margin-bottom: 0;
    font-size: 16px;
    font-weight: 700;
  }

  .item3 {
    height: 0px;
    margin-bottom: 2px;
    width: 100%;
  }

  .item4 {
    border-top: 1px solid #e8e8e8;
    padding-top: 5px;
    margin-top: 8px;
    font-size: 14px;
    line-height: 22px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    span:last-child {
      margin-left: 8px;
      color: rgba(0, 0, 0, 0.85);
    }
  }
}

.engineer {
  display: flex;
  background-color: white;
  margin-bottom: 10px;
  border-radius: 5px;
  padding: 10px;
  margin-right: 5px;

  .engineer-img {
    height: 60px;
    width: 60px;
    margin-right: 10px;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      border-radius: 50px;
    }
  }

  .engineer-name {
    .nickName {
      font-size: 16px;
      color: black;
      font-weight: 400;
      cursor: pointer;
    }

    .type {
      font-size: 12px;
      color: gray;
      font-weight: normal;
      cursor: pointer;
    }
  }

  .engineer-state {
    // display: inline-block;
    p {
      //font-size: 12px;
      margin-right: 8px;
      display: inline-block;
    }
  }
}

/deep/ .ivu-radio-checked .ivu-radio-inner {
  border-color: #2a75ed !important;
}

/deep/ .ivu-radio-inner:after {
  background-color: #2a75ed !important;
}
</style>
